import React from "react";
import { Search, X, CornerDownLeft } from "lucide-react";
import { SearchBarProps } from "./types";

export const SearchBar: React.FC<SearchBarProps> = ({
  searchTerm,
  setSearchTerm,
  searchInputRef,
}) => {
  return (

    <div className=""> 
      <div className="relative">
        <input
          ref={searchInputRef}
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search nodes..." // Updated placeholder
          className="search-input w-full pl-10 pr-10 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-700 dark:text-gray-100 dark:placeholder-gray-400"
        />
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 dark:text-gray-500 pointer-events-none" />
        {/* Show Enter hint only when input is not focused AND search term is empty */}
        {!document.activeElement?.isSameNode(searchInputRef.current) && !searchTerm && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2 px-1 py-0.5 dark:text-gray-500 text-gray-400 pointer-events-none">
            <CornerDownLeft className="w-4 h-4" />
          </div>
        )}
        {searchTerm && (
          <button
            onClick={() => {
              setSearchTerm("");
              searchInputRef.current?.focus(); // Keep focus after clearing
            }}
            className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-600 p-1" // Adjusted padding for better click area
          >
            <X className="h-4 w-4 text-gray-500 dark:text-gray-400" />
          </button>
        )}
      </div>
    </div>
  );
};
